import React from "react"
import { AnalyticsThemeProvider } from "@app"

import overrideComponents from "./overrides"
import { dsColorNew, rentacarPalette } from "./palette"
import { toastGlobalStyles } from "./toasts"
import { fieldGlobalStyles } from "./fields"
import { irisSkinGlobalStyles } from "./irisSkin"

export default function AppTheme({ children }) {
	return <AnalyticsThemeProvider
		global={{
			// amCharts' "no data" modal ships at z-index 100000 and covered the fixed header
			'.am5-modal': { zIndex: '1 !important' },
			// …and its white popup reads as the app's muted empty line, inside the chart's card
			'.am5-modal-content': {
				background: 'transparent !important', boxShadow: 'none !important', border: 'none !important',
				color: `${dsColorNew.textMuted} !important`, fontSize: '13px !important', fontFamily: 'Roboto, sans-serif',
			},
			'.am5-modal-curtain': { background: 'transparent !important' },
			...toastGlobalStyles,
			...fieldGlobalStyles,
			...irisSkinGlobalStyles,
		}}
		overrides={overrideComponents}
		palette={rentacarPalette}>
		{children}
	</AnalyticsThemeProvider>
}

